export default __webpack_public_path__ + "static/media/quickContactsPC.7e83dd0c.png";